// extracted by mini-css-extract-plugin
export var buttonSearch = "search-criterias-module--buttonSearch--59efe";
export var container = "search-criterias-module--container--79165";
export var containerItemsSearchBar = "search-criterias-module--containerItemsSearchBar--68b5e";
export var containerItemsSearchButton = "search-criterias-module--containerItemsSearchButton--88eab";
export var divCategorycontainer = "search-criterias-module--divCategorycontainer--7c25a";
export var h6Title = "search-criterias-module--h6Title--2af9f";
export var items = "search-criterias-module--items--38c9d";
export var itemsbottom = "search-criterias-module--itemsbottom--acb47";
export var rootDesktop = "search-criterias-module--rootDesktop--0b0f5";
export var rootSmartphone = "search-criterias-module--rootSmartphone--53971";
export var searchButtonP = "search-criterias-module--searchButtonP--ff91e";
export var searchContainer = "search-criterias-module--searchContainer--3ab24";
export var title = "search-criterias-module--title--00338";